
import { Button } from '@/components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, LogOut } from 'lucide-react';
import { useState } from 'react';
import { AppSettings } from '@/components/settings/AppSettings';
import { useAuth } from '@/contexts/AuthContext';
import { NavigationLinks } from './NavigationLinks';

export const MainNavigation = () => {
  const navigate = useNavigate();
  const { isAuthenticated, userRole, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const closeMenu = () => setIsOpen(false);

  // Get the current page title based on the route
  const getPageTitle = () => {
    if (location.pathname === '/peo/dashboard') return 'PEO Dashboard';
    if (location.pathname === '/dashboard') return 'Dashboard';
    return '';
  };

  const pageTitle = getPageTitle();

  return (
    <nav className="fixed w-full bg-primary/95 backdrop-blur-lg shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-12">
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img 
                src="/lovable-uploads/d2d96d93-b158-4944-83f3-a8801b083f0c.png" 
                alt="The PEO App Logo" 
                className="h-10 w-auto" 
              />
              {pageTitle && (
                <span className="ml-2 text-white font-medium text-sm">{pageTitle}</span>
              )}
            </a>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <NavigationLinks layoutMode="horizontal" textSize="xs" />
            {isAuthenticated && <AppSettings />}
            {isAuthenticated ? (
              <Button
                onClick={logout}
                variant="outline"
                className="bg-white text-primary hover:bg-gray-50 flex items-center gap-1"
                size="sm"
              >
                <LogOut className="h-3 w-3" />
                Logout
              </Button>
            ) : (
              <Button
                onClick={() => navigate('/login')}
                variant="outline"
                className="bg-white text-primary hover:bg-gray-50"
                size="sm"
              >
                Login
              </Button>
            )}
          </div>
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-gray-200 focus:outline-none"
            >
              {isOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>
      
      {isOpen && (
        <div className="md:hidden bg-primary/95 backdrop-blur-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <NavigationLinks layoutMode="vertical" textSize="xs" onClick={closeMenu} />
            {isAuthenticated && (
              <div className="px-3 py-2">
                <AppSettings />
              </div>
            )}
            {isAuthenticated ? (
              <Button
                onClick={() => {
                  closeMenu();
                  logout();
                }}
                variant="outline"
                className="w-full bg-white text-primary hover:bg-gray-50 flex items-center gap-1"
                size="sm"
              >
                <LogOut className="h-3 w-3" />
                Logout
              </Button>
            ) : (
              <Button
                onClick={() => {
                  closeMenu();
                  navigate('/login');
                }}
                variant="outline"
                className="w-full bg-white text-primary hover:bg-gray-50"
                size="sm"
              >
                Login
              </Button>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};
